import { render, staticRenderFns } from "./ChatComment.vue?vue&type=template&id=7b67fe9d&"
import script from "./ChatComment.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ChatComment.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ChatComment.vue?vue&type=style&index=0&id=7b67fe9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports